import { lazy } from "common/load/componentUtils";

import { CloseProp, useDrawer } from "client/common/hooks/stackables";

import type { OrderCancelationDrawerProps } from "../components/OrderCancelationDrawer";
import type { OrderPaymentUpdateDrawerProps } from "../components/OrderPaymentUpdateDrawer";

const OrderCancelationDrawer = lazy(() => import("../components/OrderCancelationDrawer"));
const OrderPaymentUpdateDrawer = lazy(() => import("../components/OrderPaymentUpdateDrawer"));

export const useOrderCancelationDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: OrderCancelationDrawerProps & CloseProp) => open(OrderCancelationDrawer, props),
  };
};

export const useOrderPaymentUpdateDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: OrderPaymentUpdateDrawerProps & CloseProp) =>
      open(OrderPaymentUpdateDrawer, props),
  };
};
